// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__230z5","tab":"ProcedureTabs_tab__38HuD"};